export default __webpack_public_path__ + "static/media/21.177c75b3.jpg";